export default function Footer(){
    return(
        <footer >
            <div className="flex align-items-center justify-space-beetween to-center ">

                <div>
                    <h6>Yugioh® is a trademark property of Konami®</h6>
                </div>
                <div>
                    <h6>Developed by Fernando Cruz.</h6>
                    <h6>Contact me at: 
                        <a href="https://www.linkedin.com/in/cruzfernandomartin/">LinkedIn</a>
                    </h6>
                </div>
            </div>
        </footer>
    )
}